var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTypcnInfoLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "typcn:info-large"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.22627 11.683C9.22227 11.6843 8.85361 11.807 8.53361 11.807C8.35694 11.807 8.28561 11.7703 8.26294 11.7543C8.15094 11.6763 7.94294 11.5303 8.29894 10.821L8.96561 9.49167C9.36094 8.70234 9.41961 7.93901 9.12894 7.34167C8.89161 6.85301 8.43627 6.51767 7.84894 6.39767C7.63877 6.35466 7.4248 6.33299 7.21027 6.33301C5.9776 6.33301 5.14761 7.05301 5.11294 7.08367C5.05506 7.13469 5.01667 7.20419 5.00431 7.28035C4.99195 7.3565 5.00639 7.43459 5.04516 7.50128C5.08394 7.56798 5.14465 7.61916 5.21694 7.6461C5.28924 7.67304 5.36864 7.67407 5.44161 7.64901C5.44494 7.64767 5.81427 7.52434 6.13427 7.52434C6.30961 7.52434 6.38027 7.56101 6.40227 7.57634C6.51494 7.65501 6.72361 7.80301 6.36827 8.51101L5.70161 9.84101C5.30561 10.631 5.24761 11.3943 5.53827 11.991C5.77561 12.4797 6.23027 12.815 6.81894 12.935C7.02827 12.977 7.24294 12.9997 7.45494 12.9997C8.68827 12.9997 9.51894 12.2797 9.55361 12.249C9.61153 12.1981 9.65003 12.1287 9.66253 12.0526C9.67503 11.9765 9.66076 11.8985 9.62215 11.8317C9.58355 11.765 9.523 11.7137 9.45081 11.6865C9.37863 11.6594 9.29927 11.6582 9.22627 11.683Z",
    fill: "#30891A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.66667 5.66634C9.58714 5.66634 10.3333 4.92015 10.3333 3.99967C10.3333 3.0792 9.58714 2.33301 8.66667 2.33301C7.74619 2.33301 7 3.0792 7 3.99967C7 4.92015 7.74619 5.66634 8.66667 5.66634Z",
    fill: "#30891A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypcnInfoLarge);
export default __webpack_public_path__ + "static/media/typcn_info-large.17fb737a2a53df8a97047f5e5256f8e4.svg";
export { ForwardRef as ReactComponent };